var _mask, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 28,
    viewBox: "0 0 44 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.2C0.5 2.14801 2.13142 0.5 4.125 0.5H39.875C41.8686 0.5 43.5 2.14801 43.5 4.2V23.8C43.5 25.852 41.8686 27.5 39.875 27.5H4.125C2.13142 27.5 0.5 25.852 0.5 23.8V4.2Z",
    fill: "white",
    stroke: "#F2EFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.2C0 1.8804 1.84683 0 4.125 0H39.875C42.1532 0 44 1.8804 44 4.2V23.8C44 26.1196 42.1532 28 39.875 28H4.125C1.84683 28 0 26.1196 0 23.8V4.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 23.1001H0V28.0001H44V23.1001Z",
    fill: "#F7B600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V4.9H44V0Z",
    fill: "#1A1F71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0708 8.59779L12.6771 19.4295H9.81089L7.64864 10.785C7.5176 10.2535 7.40337 10.0581 7.00463 9.83344C6.35256 9.46736 5.27599 9.125 4.32959 8.91209L4.39354 8.59779H9.0078C9.59557 8.59779 10.1243 9.00189 10.2587 9.70146L11.4009 15.9699L14.2219 8.59779H17.0708ZM28.3014 15.8933C28.3133 13.0347 24.4776 12.8763 24.503 11.599C24.5114 11.2109 24.8695 10.7975 25.6528 10.6918C26.041 10.64 27.1125 10.5982 28.3272 11.1765L28.8021 8.87859C28.1497 8.63472 27.3102 8.3999 26.2658 8.3999C23.585 8.3999 21.6992 9.87128 21.6841 11.9803C21.667 13.5399 23.0312 14.4093 24.057 14.9287C25.1144 15.4595 25.469 15.8001 25.4638 16.2744C25.4564 17.0011 24.6204 17.3229 23.8422 17.335C22.4779 17.3571 21.6875 16.9541 21.0571 16.6504L20.565 19.0251C21.1996 19.3253 22.369 19.5865 23.5796 19.5999C26.4295 19.5997 28.293 18.1454 28.3014 15.8933ZM35.3805 19.4295H37.8878L35.6972 8.59779H33.3843C32.8629 8.59779 32.4237 8.9101 32.2291 9.39186L28.1602 19.4297H31.008L31.5733 17.8121H35.0518L35.3805 19.4295ZM32.3535 15.592L33.7809 11.5242L34.6021 15.592H32.3535ZM20.9453 8.59779L18.7034 19.4295H15.9917L18.2339 8.59779H20.9453Z",
    fill: "#1A1F71"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.2C0.5 2.14801 2.13142 0.5 4.125 0.5H39.875C41.8686 0.5 43.5 2.14801 43.5 4.2V23.8C43.5 25.852 41.8686 27.5 39.875 27.5H4.125C2.13142 27.5 0.5 25.852 0.5 23.8V4.2Z",
    stroke: "#F2EFEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVisa);
export default __webpack_public_path__ + "static/media/payment-visa.8673e15151f41f0a2d98ad78a65767e9.svg";
export { ForwardRef as ReactComponent };